// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2q3X8","actionsCol":"EnrolledClinics_actionsCol__vPDeK"};